const fa = {
    heloo: "سلام",
    change_language: "تغییر  زبان",
    home: "خانه",
    create_augmented_reality: "ایجاد واقعیت افزوده",
    orders: "سفارشات",
    payments: "پرداختی ها",
    camera: "دوربین",
    constructed_augmented: "واقعیت افزوده های ساخته شده ",
    total_payments: "مجموع پرداختی ها",
    number_views_files: "تعداد بازدید همه فایل ها",
    augmented_gallery: "گالری واقعیت افزوده ها",
    view_all: "مشاهده همه",
    gallery_videos: "گالری ویدئو ها و اخبار",
    number_of_visits: "تعداد بازدید",
    production_date: "تاریخ ساخت",
    video_not_found: "ویدیو تبلیغاتی یافت نشد",
    profile: "پروفایل",
    edit_profile: "ویرایش پروفایل",
    edit: "ویرایش",
    sign_out: "خروج از حساب",
    Your_profile_is_inactive: "پروفایل شما غیر فعال میباشد",
    fill_the_box_below: " لطفا کادر زیر را پر کنید",
    augmented_reality_code: "کد واقعیت افزوده",
    registration: "ثبت",
    link: "لینک",
    financial_reports: "گزارشات مالی",
    search: "جستجو",
    search_in: "جستجو کنید...",
    Paid: 'پرداخت شد',
    Repayment: "پرداخت مجدد",
    free: "رایگان",
    yearly: "سالیانه",
    create_two_images: "ایجاد دو تصویر",
    ten_visits_per_year: "10 بازدید در سال",
    business_facilities: "امکانات کسب و کار",
    selection: "انتخاب",
    business: "کسب و کار",
    toman: "تومان",
    no_visit_limit: "بدون محدودیت بازدید در سال",
    extendable: "قابلیت تمدید سالیانه",
    ability_multiple_images: "امکان اضافه کردن چند تصویر (با هزینه کمتر)",
    hyperlink: "هایپرلینک ها(وبسایت، تماس، اینستاگرام، راهنما)",
    personal: "شخصی",
    visits_per_year_360: "360 بازدید در سال",
    create_an_image: "ایجاد یک تصویر",
    the_image_below_is_5mb: "تصویر زیر ۵ مگابایت باشد",
    the_video_below_is_50mb: "ویدیو زیر ۵۰ مگابایت باشد",
    your_photo: "عکس شما",
    tip: "نکته",
    your_video: "ویدئو شما",
    names: "نام",
    more_settings: "+ تنظیمات بیشتر",
    fewer_settings: "- تنظیمات کمتر ",
    price: "قیمت",
    send: "ارسال",
    uploading: "درحال آپلود، این عملیات ممکن است چند دقیقه طول بکشد لطفا منتظر باشید",
    site_link: "لینک سایت",
    help_site: 'سایت راهنما',
    phone_number: "شماره تماس",
    your_qr_code: "کیو ار کد شما",
    scan_qr_code: "شما میتوانید کیو آر کد زیر را اسکن و یو آر ال را دانلود یا کپی کنید",
    dates: "تاریخ",
    visit: "بازدید",
    copy: "کپی",
    download_qr_code: "دانلود کیو ار کد ",
    successful_payment: "پرداخت موفقیت آمیز",
    thank_you_for_payment: "از اینکه پرداخت آنلاین امن خود را تکمیل کردید متشکریم",
    are_you_sure_to_exit: "آیا برای خروج مطئن هستید",
    yes_im_sure: "بله مطمئنم",
    no_thanks: "نه ممنون",
    cancel_augmented_reality: "لغو واقعیت افزوده",
    download: "دانلود",
    please_enter_augmented: "لطفا شناسه واقعیت افزوده را وارد کنید",
    id: "شناسه",
    please_wait: "لطفا صبر کنید",
    instagram_username: "نام کاربری اینستاگرام (بدون نشانه @ وارد کنید)",
    create_an_account: "ایجاد حساب برای ای آر لایو",
    complete_the_form: "تکمیل فرم برای ایجاد حساب کاربری",
    form_registration: "نام و نام خانوادگی (نام مجموعه)",
    phone: "شماره همراه ",
    select_the_country: "کشور را انتخاب کنید",
    user_name: "نام کاربری",
    please_use_english: "لطفا فقط از حروف انگلیسی استفاده شود",
    password: "رمز عبور",
    password_must_be_six_digits: "رمز عبور باید بیشتر از 6 کاراکتر و ترکیبی از اعداد و حروف باشد",
    show_password: "نشان دادن پسورد",
    repeat_the_password: "تکرار رمز عبور",
    select_the_language: "تغییر زبان",
    register: "ثبت نام",
    register_the_code: "ثبت کد",
    enter_code: "کد را وارد کنید",
    sent: "ارسال شد",
    code_for_the_number: "کد برای شما",
    have_you_registered: "ثبت نام کرده اید؟",
    log_in: "ورود",
    create_a_new_user_account: "ایجاد حساب کاربری جدید",
    create_password_to_six: "ایجاد پسورد تا شیش رقم",
    password_not_the_same: "پسورد یکسان نیست",
    You_currently_with_account: "شما درحال حاضر با اکانت خود ورود کرده اید",
    verification_code_is_incorrect: "کد تایید نادرست است",
    registration_was_successful: "ثبت نام شما با موفقیت انجام شد",
    fill: "را پر کنید",
    login_to_account: "ورود به حساب کاربری",
    login_via_password: "ورود از طریق گذرواژه",
    log_via_sms: "ورود از طریق پیامک",
    form_nameValidation: "تلفن همراه یا نام کاربری",
    send_code: "کد ارسال شده",
    you_are_not_authenticated: "شما هنوز احراز هویت نشده اید",
    not_registered: " ثبت نام نکرده اید؟",
    passwordValidation: "پسورد",
    code_successfully_verified: "کد با موفقیت تایید شد",
    please_fill_name_validation: "لطفا نام را پر کنید",
    please_fill_picture_validation: "لطفا عکس را پر کنید",
    you_cannot_multiple_photos_validation: "شما نمیتوانید چند تا عکس تعریف کنید",
    do_not_duplicate_videos_validation: "ویدیو تکراری اضافه نکنید",
    do_not_duplicate_photos_validation: "عکس تکراری اضافه نکنید",
    video_more_50_MB_validation: "ویدیو بیشتر از ۵۰ مگابایت",
    image_size_5mb_validation: 'سایز تصویر بیشتر از ۵ مگابایت می باشد',
    fill_in_video_validation: "ویدیو را پر کنید",
    fill_in_image_validation: "عکس را پرکنید",
    your_video_photos: "ویدیو و عکس های شما",
    image: "عکس",
    video: "ویدیو",
    payment_was_successful: 'پرداخت با موفقیت انجام شد',
    go_to_home_page: "انتقال به صفحه اصلی",
    product_id: "آیدی محصول",
    return_main_page: "بازگشت به صفحه ی اصلی",
    difficulty_paying: "مشکل در پرداخت",
    payment_not_successful: "پرداخت موفقیت آمیز نبود",
    make_the_operation: "جهت تکمیل عملیات دوباره پرداخت را انجام دهید",
    return_the_page: "بازگشت به صفحه ی اصلی",
    you_not_access: "شما دسترسی ندارید",
    qr_code: "کیو ار کد",
    link_was_copied: "لینک کپی شد",
    oreders: "سفارشات",
    payment_message: "پیغام پرداخت",
    payment_failed: "پرداخت ناموفق",
    payment_code: "شناسه پرداخت",
    does_not_exist: "وجود ندارد",
    card_number: "شماره کارت",
    wait: "صبر کنید",
    mission_was_successful: "عملیات  با موفقیت انجام شد",
    Upload_a_new_video: "آپلود ویدئو جدید",
    Delete_augmented_reality: "حذف واقعیت افزوده",
    Are_you_sure_about_removing_augmented_reality: "آیا از حذف واقعیت افزوده اطمینان دارید؟",
    Are_you_sure_about_canceling_augmented_reality: "آیا از لغو واقعیت افزوده اطمینان دارید؟",
    yes: "بله",
    no: "خیر",
    receive: "دریافت کد",
    sendCodeSms: "ارسال کد  ",
    change_password: "تغییر گذرواژه",
    enterNumber: "شماره را وارد کنید",
    add: "اضافه کردن",
    convertVideo: "درحال تبدیل ویدیو لطفا منتظر بمانید",
    no_augmented: "واقعیت افزوده ای یافت نشد",


}
export default fa;